import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconFaq24pxMedium = function IconFaq24pxMedium(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 8c-1.143 0-2 .88-2 1.88a1 1 0 11-2 0C8 7.699 9.83 6 12 6s4 1.699 4 3.88c0 1.393-.755 2.599-1.86 3.278-.353.218-.66.456-.868.704-.205.242-.272.436-.272.598V15a1 1 0 11-2 0v-.54c0-.778.342-1.414.745-1.89.399-.472.9-.84 1.347-1.115.56-.344.908-.93.908-1.575 0-1-.857-1.88-2-1.88z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13 18a1 1 0 11-2 0 1 1 0 012 0z"
    })]
  }));
};
export default IconFaq24pxMedium;